<h1 mat-dialog-title>Modifier le commentaire</h1>
<div mat-dialog-content>
  <mat-form-field>
    <textarea matInput [(ngModel)]="data.comment"></textarea>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Annuler</button>
  <button mat-button [mat-dialog-close]="data.comment">Enregistrer</button>
</div>

